import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DEFAULT_LOCALE, isSupportedLocale } from "@/hooks/useLocale";

export default function LocaleRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const browser = (navigator.language || "").split("-")[0].toLowerCase();
    const target = isSupportedLocale(browser) ? browser : DEFAULT_LOCALE;
    navigate(`/${target}`, { replace: true });
  }, [navigate]);

  return null;
}